import ReactedRemark from './reacted-remark';
export default ReactedRemark;
